import React, { useState, useEffect } from 'react';
import { changeRental } from "../../../api/apiRequests";
import PieceOfInfo from "../../shared/PieceOfInfo";
import trash from "./../../../media/icons/trash.svg"
// import technics from "./../../../media/icons/technics.svg"
// import technicsOk from "./../../../media/icons/technicsOk.svg"
// import eye from "./../../../media/icons/eye.svg"
import play from "./../../../media/icons/play.svg"
import pause from "./../../../media/icons/pause.svg"
import { ToolTip } from "../../shared/allToolTips";

const DisplayVespas = ({ rentals, updateRentals, ...props }) => {
  const [models, setModels] = useState([])

  useEffect(() => {
    const ms = props.models
    setModels(Object.keys(ms).map(key => ms[key]))
  }, [props.models])

  const deleteVespa = (id) => {
    changeRental(id, { active: false }).then(() => {
      updateRentals();
      alert("La vespa se ha eliminado del sistema")
    }).catch(() => {
      alert("No se ha podido eliminar la vespa")
    })
  };

  // const mechanicVespa = (id, causesOfUnavailability) => {
  //   changeRental(id, { causesOfUnavailability }).then(() => {
  //     updateRentals();
  //     alert(causesOfUnavailability.length <= 0 ? "La vespa ha salido del mecanico" : "La vespa se encuentra en el mecanico")
  //   }).catch(() => {
  //     alert("No se ha podido modificar la vespa")
  //   })
  // };

  // const showVespa = (id, newPublished) => {
  //   changeRental(id, { published: newPublished }).then(() => {
  //     updateRentals();
  //     alert(newPublished ? "La vespa es visible al publico" : "La vespa no es visible al publico")
  //   }).catch(() => {
  //     alert("No se ha podido modificar la vespa")
  //   })
  // };

  const pausedPlayVespa = (id, newState) => {
    changeRental(id, { paused: newState }).then(() => {
      updateRentals();
      alert(newState ? "La actividad de la vespa ha sido pausada" : "La actividad de la vespa se ha reanudado")
    }).catch(() => {
      alert("No se ha podido modificar la vespa")
    })
  };

  const filterRentals = model => rentals.filter(rental => rental.model._id === model._id)
    
  return (
    <React.Fragment>
      <ToolTip.PlayVespa />
      <ToolTip.ShowVespa />
      <ToolTip.MechanicVespa />
      <ToolTip.DeleteVespa />
      <div className="container-fluid py-4">
        {rentals.length === 0 ? <span>CARGANDO VESPAS...</span> :
          models.map((model, key) => {
            return (
              <React.Fragment key={key}>
                <h5 className="mt-5 row" >MODELO {model.name}</h5>
                {filterRentals(model).map((rental, key) => <PieceOfInfo key={key} title={"Matricula: " + rental.licensePlate}>
                  <div className="d-flex w-100 justify-content-end">
                    <img data-tip={rental.paused ? "Estado actual: PAUSADO" : "Estado actual: ACTIVO"}
                      data-for="pausePlayVespa"
                      onClick={() => pausedPlayVespa(rental._id, !rental.paused)}
                      style={{ cursor: "pointer" }} className="mx-1" width="20px" height="20px"
                      src={rental.paused ? play : pause} alt="" />
                    {/* <img data-tip={rental.published ? "Estado actual: PUBLICADO" : "Estado actual: OCULTO"}
                      data-for='showVespas' onClick={() => showVespa(rental._id, !rental.published)}
                      style={{ cursor: "pointer", opacity: (rental.published ? 1 : 0.6) }} className="mx-1" width="20px"
                      height="20px" src={eye} alt="" />
                    <img
                      data-tip={rental.causesOfUnavailability.length > 0 ? "Estado actual: EN REPARACIÓN" : "Estado actual: APTO"}
                      data-for='mechanicVespas'
                      onClick={(rental.causesOfUnavailability.indexOf("mechanic") < 0) ? () => mechanicVespa(rental._id, ["mechanic"]) : () => this.mechanicVespa(rental._id, [])}
                      style={{ cursor: "pointer" }} className="mx-1" width="20px" height="20px"
                      src={rental.causesOfUnavailability.length > 0 ? technics : technicsOk} alt="" /> */}
                    <img data-tip={true} data-for="deleteVespa" onClick={() => deleteVespa(rental._id)}
                      style={{ cursor: "pointer" }} width="20px" height="20px"
                      src={trash} alt="" />
                  </div>
                </PieceOfInfo>)}
              </React.Fragment>
            )
          })
        }
      </div>
    </React.Fragment>
  );
}

export default DisplayVespas;
